import React, { useEffect } from "react";

const PrivacyPolicy = () => {
 useEffect(() => {
  window.scrollTo(0, 0);
}, []);


  return (
    <div style={styles.container} className="background-clr">
      <h1 style={styles.title}>Privacy Policy</h1>

      <p style={styles.date}>
        <strong>Effective Date:</strong> 15th December 2025
      </p>

      <p>
        Thank you for choosing <strong>DigiDoc</strong> ("we," "our," or "us").
        Your privacy is important to us. This Privacy Policy explains how we
        collect, use, and protect your information when you use the DigiDoc
        mobile application ("App").
      </p>

      <Section title="1. Information We Collect">
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, age, gender, contact
            details (phone number, email), and profile photo.
          </li>
          <li>
            <strong>Health Information:</strong> Medical history, prescriptions,
            treatment plans, appointments, and doctor communications.
          </li>
          <li>
            <strong>Device & Usage Data:</strong> Device type, IP address, app
            usage statistics, and error reports.
          </li>
          <li>
            <strong>Location Data:</strong> With your permission, to help locate
            nearby doctors or clinics.
          </li>
        </ul>
      </Section>

      <Section title="2. How We Use Your Information">
        <ul>
          <li>Book and manage your appointments with healthcare providers.</li>
          <li>Provide reminders for medicines, treatments, or follow-ups.</li>
          <li>Deliver digital prescriptions and reports.</li>
          <li>Maintain your health records securely.</li>
          <li>Improve app performance and user experience.</li>
          <li>Comply with legal obligations.</li>
        </ul>
      </Section>

      <Section title="3. How We Share Your Information">
        <ul>
          <li>
            With doctors and healthcare providers you book through DigiDoc.
          </li>
          <li>
            With third-party service providers (e.g., cloud storage, analytics)
            under strict confidentiality agreements.
          </li>
          <li>When required by law or to protect our rights.</li>
        </ul>
      </Section>

      <Section title="4. Data Security">
        <p>
          We use industry-standard security measures, including encryption, to
          protect your data. However, no system is 100% secure, so we encourage
          you to use strong passwords and keep your device secure.
        </p>
      </Section>

      <Section title="5. Your Rights">
        <ul>
          <li>Access, update, or delete your personal data.</li>
          <li>
            Withdraw consent at any time (may affect app functionality).
          </li>
          <li>Request a copy of the data we hold about you.</li>
        </ul>
      </Section>

      <Section title="6. Data Retention">
        <p>
          We retain your data only as long as needed to provide our services or
          comply with legal obligations.
        </p>
      </Section>

      <Section title="7. Contact Us">
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:support@digidoc.co.in">
            support@digidoc.co.in
          </a>
        </p>
        <p>
          <strong>Address:</strong> S2, 21, Srinivasa Nagar, Kandanchavadi,
          Perungudi, Chennai, Tamil Nadu 600096.
        </p>
      </Section>
    </div>
  );
};

/* 🔹 Reusable Section Component */
const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h2 style={styles.heading}>{title}</h2>
    {children}
  </div>
);

/* 🔹 Simple Styling */
const styles = {
  container: {
    // maxWidth: "900px",
    margin: "40px auto",
    padding: "20px 40px",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.7,
    color: "#333",
  },
  title: {
    textAlign: "center",
    marginBottom: "10px",
    color: "#4da9ff",
    
  },
  date: {
    textAlign: "center",
    marginBottom: "30px",
    color: "#555",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    marginBottom: "10px",
    color: "#4da9ff",  	
  },
};

export default PrivacyPolicy;
